<template lang="pug">
  .cart-subscribe-and-save.xs-12.background-gray-light.xs-mt-100m.xs-pt-50m.xs-pb-50m(v-if="!hasMembershipPricing && !!subscribableItems.size")
    .icon-heart-refresh.color-primary.xs-f-xgrande.max-at-tweak.xs-pl-25m
      span.ada-tooltip heart icon

    .description.xs-pl-25m
      p.xs-f-xsmall.max-at-tweak.upper.color-mr-purple {{settings.title}}
      p.xs-f-xsmall.max-at-tweak.light {{settings.description}}
      button#cart-subscribe-and-save.transparent-btn.underline.xs-f-small.max-at-tweak(@click="editOneTimeProducts" data-mr-ass="subscribe-and-save") {{settings.ctaText}}

</template>

<script>
  import { mapGetters, mapMutations } from 'vuex';

  // TODO - Once this is set up ensure to implement ctaSource on CartItem componenet line 150
  export default {
    name: "CartSubscribeAndSave",
    
    data() {
      return {
        settings: {
          title: 'Reasons to love auto delivery:',
          description: 'You set the schedule, save money on every order, more free time, more me time',
          ctaText: 'Subscribe and Save',
        }
      }
    },

    computed: {
      ...mapGetters('customer', ['hasMembershipPricing']),
      ...mapGetters('cart', ['subscribableItems'])
    },

    methods: {
      ...mapMutations('cart', ['setEditAllItems']),

      editOneTimeProducts() {
        this.setEditAllItems(true);
        this.trackEvent('Cart Auto Delivery Batch Edit');
      }
    }
  }

</script>

<style scoped lang="stylus">
  .cart-subscribe-and-save
    display flex
    flex-direction row

</style>

